/**
 * Ambient Romantic Lofi/Acoustic Web Audio Synthesizer
 * Plays soothing, lush, romantic chord progressions seamlessly without external heavy audio files.
 */
export class AmbientMusicPlayer {
  constructor() {
    this.isPlaying = false;
    this.ctx = null;
    this.intervalId = null;
    this.masterGain = null;

    // Romantic Chord Progression in F Major / D Minor (Dreamy 7th chords)
    // Chords: Fmaj7 -> Dm9 -> Bbmaj7 -> C9sus4
    this.chords = [
      [174.61, 220.00, 261.63, 329.63, 440.00], // Fmaj7 (F3, A3, C4, E4, A4)
      [146.83, 220.00, 261.63, 293.66, 349.23], // Dm9   (D3, A3, C4, D4, F4)
      [116.54, 174.61, 233.08, 293.66, 349.23], // Bbmaj7(Bb2, F3, Bb3, D4, F4)
      [130.81, 196.00, 261.63, 293.66, 392.00]  // C9sus4(C3, G3, C4, D4, G4)
    ];
    this.chordIndex = 0;
  }

  initAudio() {
    if (!this.ctx) {
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      this.ctx = new AudioContext();
      this.masterGain = this.ctx.createGain();
      this.masterGain.gain.setValueAtTime(0.18, this.ctx.currentTime);
      this.masterGain.connect(this.ctx.destination);
    }
  }

  playChord(notes) {
    if (!this.ctx || !this.isPlaying) return;

    const now = this.ctx.currentTime;
    const duration = 3.6;

    notes.forEach((freq, i) => {
      const osc = this.ctx.createOscillator();
      const noteGain = this.ctx.createGain();

      // Warm Sine + Lowpass Triangle blend
      osc.type = i === 0 ? 'sine' : 'triangle';
      osc.frequency.setValueAtTime(freq, now + i * 0.08);

      // Soft envelope (slow attack, long decay)
      noteGain.gain.setValueAtTime(0.0001, now);
      noteGain.gain.exponentialRampToValueAtTime(0.05 / (i * 0.4 + 1), now + 0.8 + i * 0.05);
      noteGain.gain.exponentialRampToValueAtTime(0.0001, now + duration);

      // Lowpass Filter for warm acoustic feel
      const filter = this.ctx.createBiquadFilter();
      filter.type = 'lowpass';
      filter.frequency.setValueAtTime(1200 - i * 120, now);

      osc.connect(filter);
      filter.connect(noteGain);
      noteGain.connect(this.masterGain);

      osc.start(now + i * 0.08);
      osc.stop(now + duration + 0.2);
    });
  }

  toggle() {
    this.initAudio();

    if (this.ctx.state === 'suspended') {
      this.ctx.resume();
    }

    this.isPlaying = !this.isPlaying;

    if (this.isPlaying) {
      this.playNextChord();
      this.intervalId = setInterval(() => {
        this.playNextChord();
      }, 3800);
    } else {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }

    return this.isPlaying;
  }

  playNextChord() {
    const chord = this.chords[this.chordIndex];
    this.playChord(chord);
    this.chordIndex = (this.chordIndex + 1) % this.chords.length;
  }
}
